package ru.chm.gradereport.model

import kotlinx.serialization.Serializable

@Serializable
data class LoginRequest(
    val login: String,
    val password: String,
)

@Serializable
data class LoginResponse(
    val token: String,
    val user: UserDto,
)

@Serializable
data class CreateCourseRequest(
    val name: String,
    val description: String = "",
)

@Serializable
data class UpdateCourseRequest(
    val name: String,
    val description: String = "",
)

@Serializable
data class CreateReviewerRequest(
    val login: String,
    val password: String,
    val displayName: String,
)

@Serializable
data class ResetPasswordRequest(
    val password: String,
)

@Serializable
data class AssignCoursesRequest(
    val courseIds: List<String>,
)

@Serializable
data class CreateStudentRequest(
    val fullName: String,
    val studentNumber: String = "",
)

@Serializable
data class UpdateStudentRequest(
    val fullName: String,
    val studentNumber: String = "",
)

@Serializable
data class CreateSessionRequest(
    val date: String,
    val title: String = "",
    val description: String = "",
)

@Serializable
data class UpdateSessionRequest(
    val date: String,
    val title: String = "",
    val description: String = "",
)

@Serializable
data class SetAttendanceRequest(
    val studentId: String,
    val sessionId: String,
    val status: AttendanceStatus? = null,
)

@Serializable
data class CreateHomeworkRequest(
    val title: String,
    val description: String = "",
    val maxScore: Double = 10.0,
    val sessionId: String,
)

@Serializable
data class UpdateHomeworkRequest(
    val title: String,
    val description: String = "",
    val maxScore: Double = 10.0,
    val sessionId: String,
)

@Serializable
data class SetGradeRequest(
    val studentId: String,
    val homeworkId: String,
    val score: Double?,
)

/** Attach an answer from an external form to a student's homework (by uid).
 * Prefer [formUuid]: full link is built as formsBaseUrl + formUuid.
 * Legacy [url] is still accepted when formUuid is blank.
 * [payload] holds the raw JSON fields sent by the form; every key is available
 * for substitution into the configured URL template as {key}.
 */
@Serializable
data class AttachHomeworkSubmissionRequest(
    val uid: String,
    val formUuid: String? = null,
    val url: String? = null,
    val payload: Map<String, String> = emptyMap(),
)

/** Edit the answer link of an existing homework submission (admin). */
@Serializable
data class UpdateHomeworkSubmissionRequest(
    val url: String,
)

/** Acknowledge pending answers of a student-homework cell (clears highlight). */
@Serializable
data class MarkSubmissionsSeenRequest(
    val studentId: String,
    val homeworkId: String,
)

@Serializable
data class CourseFormsSettingsDto(
    val formsBaseUrl: String = "",
    /** True when a Bearer token for form POSTs is configured (token itself is never returned). */
    val formsBearerConfigured: Boolean = false,
)

@Serializable
data class UpdateCourseFormsSettingsRequest(
    val formsBaseUrl: String = "",
    /**
     * null — leave token unchanged;
     * "" — clear token;
     * non-blank — set new Bearer token required on form submission POSTs.
     */
    val formsBearerToken: String? = null,
)

@Serializable
data class CreateCheckInRequest(
    val sessionId: String,
    val ttlMinutes: Int = 10,
    /** SPA origin without hash, used to embed absolute URL into QR. */
    val pageBaseUrl: String = "",
)

@Serializable
data class SubmitCheckInRequest(
    val studentId: String,
)

@Serializable
data class ErrorResponse(
    val message: String,
)

@Serializable
data class MessageResponse(
    val message: String,
)
